import { type PolicyManager } from './policy-manager';
import { type TransientPolicy } from './policy-manager-types';

/**
 * A constrained API for interacting with the policy manager
 */
export class PolicyManagerExternalApi {
  constructor(private manager: PolicyManager, private onPolicyChange: VoidFunction) {
    this.manager.subscribe(this.onPolicyChange);
  }

  add(namespace: string, policies: TransientPolicy[]) {
    this.manager.addPolicies(namespace, policies);
  }

  remove(namespace: string) {
    this.manager.removePolicies(namespace);
  }

  hasNamespace(policy: string) {
    return this.manager.hasNamespace(policy);
  }

  summarise() {
    return this.manager.summarise();
  }
  detailedSummarise() {
    return this.manager.detailedSummarise();
  }

  destroy() {
    return this.manager.unsubscribe(this.onPolicyChange);
  }
}
